import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import GoldMiningPage from "./pages/GoldMiningPage";
import StrategyRegistryPage from "./pages/StrategyRegistryPage";
import ArenaPage from "./pages/ArenaPage";
import LivePaperPage from "./pages/LivePaperPage";
import DiamondAgentsPage from "./pages/DiamondAgentsPage";
import MissionControlPage from "./pages/MissionControlPage";
import TournamentPage from "./pages/TournamentPage";
import StrategyDNAPage from "./pages/StrategyDNAPage";
import ValidationPage from "./pages/ValidationPage";
import EuBotDashboard from "./pages/EuBotDashboard";
import MobileDashboard from "./pages/MobileDashboard";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-primary animate-pulse font-mono">LOADING SYSTEM...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/m" element={<MobileDashboard />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AlertProvider>
                <DashboardLayout>
                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="gold-mining" element={<GoldMiningPage />} />
                    <Route path="strategy-registry" element={<StrategyRegistryPage />} />
                    <Route path="arena" element={<ArenaPage />} />
                    <Route path="live-paper" element={<LivePaperPage />} />
                    <Route path="settings" element={<Settings />} />
                    {/* Secondary — accessible via URL, not in main sidebar */}
                    <Route path="diamond-agents" element={<DiamondAgentsPage />} />
                    <Route path="mission-control" element={<MissionControlPage />} />
                    <Route path="tournament" element={<TournamentPage />} />
                    <Route path="strategy-dna" element={<StrategyDNAPage />} />
                    <Route path="validation" element={<ValidationPage />} />
                    <Route path="eu-bot" element={<EuBotDashboard />} />
                  </Routes>
                </DashboardLayout>
                </AlertProvider>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: 'hsl(0 0% 7%)',
              border: '1px solid hsl(0 0% 15%)',
              color: 'white',
              fontFamily: 'IBM Plex Sans, sans-serif'
            }
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
